export default __webpack_public_path__ + "static/media/Copy of password protection.aeccc1b5.jpg";